/**
 * Project
 */
const Constants = {
    trackerInterval: 120000,
    trackerCommunicationWait: 1200,
    trackerRetryJoinTime: 3000,
    Token: '',
    Default: {
        AnnouncePeers: 10,
        MaxAnnouncePeers: 20
    },
    iceServers: {
        iceServers: [
            {
                urls: ['stun:stun.l.google.com:19302', 'stun:stun1.l.google.com:19302']
            }
        ]
    },
    AnnounceEvents: {
        Offer: 'offer',
        Offers: 'offers',
        Candidates: 'candidates',
        Answer: 'answer',
        Join: 'join',
        Config: 'config'
    },
    WSCommEvents: {
        Connected: 'CONNECT',
        Data: 'RECEIVE',
        Error: 'ERROR',
        Closed: 'CLOSED',
        Warning: 'WARN'
    },
    WebRtcEvents: {
        Peer: 'PEER',
        PeerUpdate: 'PEERUPDATE',
        Update: 'UPDATE',
        Error: 'ERROR',
        Warning: 'WARN'
    },
    PeerEvents: {
        Connect: 'connect',
        Error: 'error',
        Close: 'close',
        Signal: 'signal'
    }
};
export default Constants;
